import * as React from "react";
import { Dialog } from "./dialog";
import { noop } from "lodash";
import { ButtonContainer } from "../button-container";
import { PrimaryButton, Button } from "../button";
import { Color, ButtonColor } from "../utils/color";
import { Paragraph, Title, Size, Space, TextColor } from "../typography";
const css = require("./confirmation-dialog.scss");
const { cloneElement } = React;

export interface ConfirmationDialogProps {
  visible: boolean;
  danger?: boolean;
  title: string | React.ReactElement<any>;
  description?: string | React.ReactElement<any>;
  cancelButton?: string | React.ReactElement<any>;
  confirmButton: string | React.ReactElement<any>;
  to?: string;
  onCancel(): void;
  onConfirm?(event: React.MouseEvent<HTMLElement>): void;
  [key: string]: any;
}

export class ConfirmationDialog extends React.Component<ConfirmationDialogProps, {}> {
  public static defaultProps = { styles: css };

  public render() {
    const {
      onCancel,
      onConfirm,
      danger,
      title,
      description,
      cancelButton,
      confirmButton,
      confirmButtonAriaLabel,
      className,
      styles,
      children,
      to,
      ...props
    } = this.props;
    const color = danger ? { color: Color.Red as ButtonColor } : {};
    const buttonProps = typeof to === "string" ? { to, onClick: noop } : {};
    const ariaLabel = confirmButtonAriaLabel ? confirmButtonAriaLabel : confirmButton;
    return (
      <Dialog
        title={typeof title === "string" ? title : undefined}
        {...props}
        className={[className, styles.dialog].join(" ")}
        onRequestClose={onCancel}
      >
        <header role="heading" aria-level={2}>
          <Title data-test-id="confirmation-dialog-title" size={Size.Small} className={styles.title}>
            {title}
          </Title>
        </header>
        {description ? (
          <Paragraph data-test-id="confirmation-dialog-text" size={Size.Medium} color={TextColor.Secondary} spaceAbove={Space.XXSmall}>
            {description}
          </Paragraph>
        ) : null}
        {children} {/* children would specify their own styles */}
        <footer className={styles.buttons}>
          <ButtonContainer equalize>
            {typeof cancelButton === "string" ? (
              <Button data-test-id="cancel-button" onClick={onCancel}>
                {cancelButton}
              </Button>
            ) : cancelButton ? (
              cloneElement(cancelButton, { onClick: onCancel })
            ) : null}
            {typeof confirmButton === "string" ? (
              <PrimaryButton data-test-id="confirm-button" {...color} onClick={onConfirm} aria-label={ariaLabel} {...buttonProps}>
                {confirmButton}
              </PrimaryButton>
            ) : (
              cloneElement(confirmButton, { onClick: onConfirm, ...color })
            )}
          </ButtonContainer>
        </footer>
      </Dialog>
    );
  }
}
